import React from 'react';
import PropTypes from 'prop-types';
import resolvePathname from 'resolve-pathname';
import Link from '@arcblock/www/src/components/link';
import { Location } from '@reach/router';

export default function DocLink(props) {
  const { children, href = '', ...rest } = props;
  if (href.indexOf('#') === 0) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }

  if (/https?:\/\//.test(href)) {
    return (
      <a target="_blank" href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Location>
      {({ location }) => {
        const { pathname } = location;
        const cleanUrl = resolvePathname(href, `${pathname}/`.replace(/\/+/g, '/'));
        return (
          <Link to={cleanUrl} {...rest}>
            {children}
          </Link>
        );
      }}
    </Location>
  );
}

DocLink.propTypes = {
  children: PropTypes.any.isRequired,
  href: PropTypes.string.isRequired,
};
